import * as React from "react";
import { forwardRef } from "react";
const SvgStarSubscribedNavMb = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 12, viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.99996 0.5L7.80916 4.00985L11.7063 4.6459L8.92731 7.45115L9.52667 11.3541L5.99996 9.578L2.47325 11.3541L3.07261 7.45115L0.293621 4.6459L4.19076 4.00985L5.99996 0.5Z", fill: "white" }));
const ForwardRef = forwardRef(SvgStarSubscribedNavMb);
export { ForwardRef as ReactComponent };
